import React, { useState } from "react";
import logo from "../../img/mustard_spray.gif";
import { Grid, Icon } from "semantic-ui-react";
import Draggable from "react-draggable"; // The default
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import Tickets from '../Tickets/Tickets'

function DijonTickets(props) {
  return (
    <div id="tickets">
      <DijonCard
        width={'100%'}
        height={'100%'}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={'tickets'}
        content={
          <div style={{
              height: '100%',
              padding: '20px'
          }}>
            <Tickets
              fullscreen={props.fullscreen}
              setFullscreen={props.setFullscreen}
              selectedTicket={props.selectedTicket}
              setSelectedTicket={props.setSelectedTicket}
            />
          </div>
        }
      />

    </div>
  );
}

export default DijonTickets;
